export default __webpack_public_path__ + "static/media/blog-02.6ecd55ed.jpg";